import i18n from 'live/services/i18n'
import EditorService from 'live/services/editor'
import widgetsService from 'live/services/widgets'
import WidgetCSBImpl, { CONFIG, widgetType } from './config/WidgetCSBImpl'
import Editor from './editor/editor-csb'
import { ProviderImport } from '../../wellimport/WellImport/providers/ProviderImport'
import _ from 'lodash'
import { addWidgetEditorToMenu } from 'plugin-assets/shared/widget/lib/util'
import { canManageWells } from '../../utils/permission'

widgetsService.impl(widgetType, WidgetCSBImpl)
widgetsService.queryHandlerKind(widgetType, widgetType)
widgetsService.config(widgetType, CONFIG)
widgetsService.policies(widgetType, {
    handleOwnMissingData: true
})

const EditorInfo = {
    order: 2,
    type: widgetType,
    label: i18n('CSB chart'),
    description: i18n('Import a CSB chart'),
    iconClass: 'fa fa-bar-chart',
    thumbnail: require('../../../assets/thumb_csb.png').default,
    tags: ['assets', 'csb', 'well-barrier']
}

EditorService.newEditor({
    name: EditorInfo.type,
    editor: Editor,
    defaultWidgetType: widgetType
})

addWidgetEditorToMenu(EditorInfo)

widgetsService.editor(widgetType, EditorInfo.type)
widgetsService.ui(widgetType, { editor: EditorInfo.type })

if (canManageWells()) {
    new ProviderImport().getWebExtensionInstances().then(configs => {
        if (_.some(configs, config => config?.enableCsb)) {
            EditorService.newEditorMenuOption(EditorInfo.type, EditorInfo)
        }
    })
}
